<template>
    <v-tooltip bottom :open-delay="500">
        <template v-slot:activator="{ on }">
            <v-btn
                icon
                @click="click"
                v-on="on"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </template>

        New file
    </v-tooltip>
</template>

<script>
export default {
    name: "SpoiledNewButton",
    methods: {
        click() {
            this.$store.commit('Log/clear');
        },
    },
}
</script>

<style scoped>

</style>